import { Types } from '@grandvisionhq/graphql';
import { isDefined, getLocalizedString, isNumber } from '@grandvisionhq/utils';
import { createProductTypeName } from '../utils/create-product-type-name.js';
import { getDiscount } from '../utils/get-discount.js';

const mapGraphProductToListingProduct = (product, intl)=>{
    const { locale  } = intl;
    const slug = product.slug;
    const productType = createProductTypeName(product.productType);
    if (!slug || !productType || !product.variants || product.variants.length === 0) {
        console.error('No slug, objectId, productType or variants found for product slug: ', product.slug);
        return undefined;
    }
    const masterVariant = mapVariant(product, product.variants[0], locale);
    if (!masterVariant) {
        console.error('No variants found for product slug: ', product.slug);
        return undefined;
    }
    const otherVariants = product.variants.slice(1).map((variant)=>mapVariant(product, variant, locale)
    ).filter(isDefined);
    const localizedName = getLocalizedString(product.nameAllLocales, locale);
    return {
        masterVariant,
        name: {
            en: product.name,
            localized: localizedName
        },
        productType,
        slug,
        variants: otherVariants
    };
};
const mapVariant = (product, variant, locale)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    const images = variant.media.images.map((img)=>({
            url: img.url,
            label: img.label || '',
            altTag: '',
            dimensions: {
                w: img.dimensions.w,
                h: img.dimensions.h
            }
        })
    );
    const prices = variant.priceList.find((priceListItem)=>priceListItem.priceType === Types.ProductPriceItemType.SINGLE_PURCHASE
    );
    if (!prices || !prices.originalPrice) {
        console.error('No prices found for product sku: ', variant.sku);
        return undefined;
    }
    var ref15, ref16;
    return {
        brand: {
            name: product.brand
        },
        description: variant.description || '',
        name: variant.displayName,
        sku: variant.sku,
        tag: ((ref = variant.tags) === null || ref === void 0 ? void 0 : ref[0]) ? {
            key: variant.tags[0].key,
            value: variant.tags[0].value
        } : undefined,
        images,
        pricing: {
            // Best price is returned as a cent amount, but the other prices are floats, therefore, we transform it into a decimal
            bestPrice: isNumber(variant.bestPrice) ? variant.bestPrice / 100 : undefined,
            price: {
                isCentAmount: false,
                originalPrice: prices.originalPrice.amount,
                currencyCode: prices.originalPrice.currencyCode,
                discount: ((ref1 = prices.discountedPrice) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : ref2.amount) ? {
                    price: (ref3 = prices.discountedPrice.price) === null || ref3 === void 0 ? void 0 : ref3.amount,
                    badge: getDiscount(locale, (ref4 = prices.discountedPrice) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.price) === null || ref5 === void 0 ? void 0 : ref5.currencyCode, (ref15 = (ref6 = prices.discountedPrice) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.discountInformation) === null || ref7 === void 0 ? void 0 : ref7.type) !== null && ref15 !== void 0 ? ref15 : undefined, (ref16 = (ref8 = prices.discountedPrice) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.discountInformation) === null || ref9 === void 0 ? void 0 : ref9.value) !== null && ref16 !== void 0 ? ref16 : undefined),
                    description: (ref10 = prices.discountedPrice.discountInformation) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.description) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.value
                } : undefined
            },
            pricePerUnit: {
                amount: (ref13 = prices.pricePerUnit) === null || ref13 === void 0 ? void 0 : ref13.amount,
                currencyCode: (ref14 = prices.pricePerUnit) === null || ref14 === void 0 ? void 0 : ref14.currencyCode
            }
        },
        isInsuranceReimbursable: variant.__typename === 'FrameVariant' && variant.variantTypeDetails.isInsuranceReimbursable,
        replacementFrequency: product.__typename === 'ContactLensProduct' ? getLocalizedString(product.productTypeDetails.replacementFrequencyAllLocales, locale) : undefined,
        contactLensCareType: variant.__typename === 'SolutionVariant' ? variant.variantTypeDetails.contactLensCareType || undefined : undefined,
        packageOption: variant.__typename === 'SolutionVariant' ? `${variant.variantTypeDetails.volume}${variant.variantTypeDetails.volumeUnit}` : undefined
    };
};

export { mapGraphProductToListingProduct, mapVariant };
//# sourceMappingURL=map-graph-product-to-listing-product.js.map
